module.exports = __webpack_public_path__ + "static/eggs-542d2871f0091499e60265d3d8ca97f6.png";